import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import { ADMIN_EMAIL } from "../../Config/admin.js";

export default function AdminRoute({ children }) {
  const { user } = useAuth();

  // Not logged in
  if (!user) {
    return <Navigate to="/signinandsignup" />;
  }

  // Not admin
  if (user.email !== ADMIN_EMAIL) {
    return <Navigate to="/" />;
  }

  return children;
}